<ng-container *ngIf="loadingStatus$ | async as loadingStatus">
  <div
    class="page-loader"
    [ngClass]="position"
    *ngIf="loadingStatus.status === 'open'"
  >
    <div>
      <app-loader [iconSize]="4"></app-loader>
      <br>
      <h2 class="title">{{ loadingStatus.title }}</h2>
    </div>
  </div>
</ng-container>
